import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle
} from "material-ui-next/Dialog";

import Icon from "material-ui-next/Icon";
import Paper from "material-ui-next/Paper";
import Tooltip from "material-ui-next/Tooltip";
import Typography from "material-ui-next/Typography";
import { FormattedNumber } from "react-intl";

import {
  CheckBox,
  Loadable,
  If,
  StyledButton,
  DescriptionField,
  TextField
} from "components/support";

import { colors } from "assets";
import { fn, debounce } from "util";

import style from "./style";
import Filter from "./filter";

class OptionalGroupsDialogView extends Component {
  async onOptionalGroupsClose() {
    const { onOptionalGroupsClose, presenter } = this.props;
    await onOptionalGroupsClose();
    presenter.resetModal();
    presenter.loadLinkedOptionalGroups();
  }

  async onOptionalGroupsSave() {
    const { onOptionalGroupsSave, presenter, viewModel } = this.props;
    const { newOptionalGroupUuids } = viewModel;
    presenter.loadLinkedOptionalGroups();
    await onOptionalGroupsSave(newOptionalGroupUuids);
  }

  render() {
    const {
      className,
      presenter,
      viewModel,
      loading,
      optionalGroupsOpen
    } = this.props;
    const { allOptionalGroups, newOptionalGroupUuids, pagination } =
      viewModel || [];
    const { page, totalPage } = pagination;

    const findCheckedOpt = uuid =>
      !!newOptionalGroupUuids.includes(uuid) ? true : false;

    return (
      <Dialog
        open={optionalGroupsOpen}
        onClose={async () => await this.onOptionalGroupsClose()}
        maxWidth="md"
        fullWidth={true}
      >
        <Loadable loading={loading} className={className}>
          <DialogTitle
            id="form-optional-groups-dialog-title"
            className="text-center"
          >
            <Row className="p-0" end="xs">
              <Col xs={12}>
                <div
                  className="close-icon"
                  onClick={async () => await this.onOptionalGroupsClose()}
                >
                  <Icon>close</Icon>
                </div>
              </Col>
            </Row>
            <Row center="xs" className="title-row">
              <Col xs={12}>
                <Typography type="headline">
                  Vínculo de Grupos de Opcionais
                </Typography>
              </Col>
            </Row>
          </DialogTitle>

          <DialogContent className="text-center dialog-content pb-0">
            <Row className="mb-md">
              <Col xs={12}>
                <Filter
                  onFilter={debounce(
                    filter => presenter.handleFilterChange(filter),
                    500
                  )}
                  loading={loading}
                />
              </Col>
            </Row>

            <If test={allOptionalGroups.length === 0}>
              <Typography type="subheading">
                Não foi encontrado nenhum Grupo de Opcionais
              </Typography>
              <Typography type="subheading">
                Caso tenha cadastrado algum, atualize a página ou entre em
                contato com o suporte
              </Typography>
            </If>
            <If test={allOptionalGroups.length > 0}>
              <Row middle="xs" center="xs" className="grid-container mb-sm">
                <Col xs={2}>
                  <Tooltip
                    key="tooltip-top-enable-opt-groups"
                    title="Habilite os grupos de opcionais que deseja vincular ao produto"
                    placement="top"
                  >
                    <div className="tooltip-div">
                      <Row center="xs" className="full-width">
                        <Col xs={4}>
                          <Icon className="tooltip-icon">info</Icon>
                        </Col>
                        <Col xs={6}>
                          <Typography type="subheading">Habilitar</Typography>
                        </Col>
                        <Col xs={2} />
                      </Row>
                    </div>
                  </Tooltip>
                </Col>
                <Col xs>
                  <Typography type="subheading">Nome</Typography>
                </Col>
                <Col xs>
                  <Typography type="subheading">Valor por Opcional</Typography>
                </Col>
                <Col xs>
                  <Typography type="subheading">Qtd Obrigatória</Typography>
                </Col>
                <Col xs>
                  <Typography type="subheading">Qtd Máxima</Typography>
                </Col>
              </Row>
              {allOptionalGroups.map((optional, i) => (
                <Row middle="xs" className="grid-container mb-sm" key={i}>
                  <Col xs={2}>
                    <CheckBox
                      checked={!!findCheckedOpt(optional.uuid)}
                      onCheck={value =>
                        presenter.onCheckOptionalGroup(value, optional.uuid)
                      }
                    />
                  </Col>
                  <Col xs>
                    <DescriptionField value={optional.name} />
                  </Col>
                  <Col xs>
                    <FormattedNumber
                      value={fn.centsToReal(optional.value)}
                      format="BRL"
                    >
                      {value => <DescriptionField value={value} />}
                    </FormattedNumber>
                  </Col>
                  <Col xs>
                    <DescriptionField
                      value={optional.mandatory_quantity || "Não tem"}
                    />
                  </Col>
                  <Col xs>
                    <DescriptionField
                      value={optional.limited_value || "Não tem"}
                    />
                  </Col>
                </Row>
              ))}

              <Paper elevation={1} className="full-width mb-md">
                <Row center="xs" middle="xs">
                  <Col xs>
                    <StyledButton
                      label="ANTERIOR"
                      disabled={page <= 1}
                      flat
                      style={{ margin: "0px 8px" }}
                      onTouchTap={() =>
                        page > 1 && presenter.onPageChange(page - 1)
                      }
                    />
                  </Col>
                  <Col xs>
                    <span>Página</span>
                    <TextField
                      fieldWidth={70}
                      type="number"
                      value={page}
                      onChange={(_, page) =>
                        presenter.onPageChange(parseInt(page, 10))
                      }
                      style={{ margin: "4px 8px 8px" }}
                      inputStyle={{ textAlign: "center" }}
                    />
                    <span>de {totalPage}</span>
                  </Col>
                  <Col xs>
                    <StyledButton
                      label="PRÓXIMO"
                      disabled={page >= totalPage}
                      flat
                      style={{ margin: "0px 8px" }}
                      onTouchTap={() =>
                        page < totalPage && presenter.onPageChange(page + 1)
                      }
                    />
                  </Col>
                </Row>
              </Paper>
            </If>
          </DialogContent>

          <DialogActions>
            <StyledButton
              flat
              accent
              label="Fechar"
              onTouchTap={async () => await this.onOptionalGroupsClose()}
              style={{ margin: "4px 8px 0px 0px", color: colors.accent.normal }}
            />
            <StyledButton
              primary
              label="Confirmar"
              onTouchTap={async () => await this.onOptionalGroupsSave()}
              style={{ margin: "4px 8px 0px 0px" }}
            />
          </DialogActions>
        </Loadable>
      </Dialog>
    );
  }
}

export default style(OptionalGroupsDialogView);



// WEBPACK FOOTER //
// ./src/components/app/registration/product/form/general-info/optional-groups/view.jsx